import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/landing/LegalPage";

export const Route = createFileRoute("/legal/cerez-politikasi")({
  head: () => ({
    meta: [
      { title: "Политика cookies — TurkeyDrive" },
      { name: "description", content: "Çerez Politikası / Политика использования cookies на платформе TurkeyDrive." },
      { property: "og:title", content: "Политика cookies — TurkeyDrive" },
      { property: "og:description", content: "Çerez Politikası / Политика использования cookies на платформе TurkeyDrive." },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <LegalPage slug="cerez-politikasi" />,
});
